var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.208 9.084c.526 0 1.051.074 1.55.242 3.076 1 4.184 4.374 3.259 7.325a10.606 10.606 0 01-2.508 4.007 32.043 32.043 0 01-5.276 4.133l-.208.126-.217-.134a31.742 31.742 0 01-5.307-4.133 10.778 10.778 0 01-2.51-4c-.941-2.95.167-6.324 3.276-7.342.242-.083.491-.142.741-.174h.1c.234-.034.467-.05.7-.05h.092a5.198 5.198 0 011.526.275h.049a.293.293 0 01.075.049c.184.06.358.126.525.218l.317.141c.076.041.162.103.236.157.047.034.09.065.122.085l.041.024c.072.042.146.085.209.133a5.219 5.219 0 013.208-1.082zm2.217 6a.685.685 0 00.658-.634v-.1a2.75 2.75 0 00-1.758-2.633.667.667 0 00-.842.417.682.682 0 00.417.857c.534.2.892.726.892 1.309v.025a.716.716 0 00.158.517.698.698 0 00.475.242z",
    fill: "#F75555"
  })));
}

export default SvgLike;